import React, { useState } from 'react';
import classes from './style.module.scss';
import { WorkOrderTaskPartList } from '~/workorder/types';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import LineTypeIcon from '~/workorder/Detail/LineTypeIcon';

export interface PartsProps {
    parts: WorkOrderTaskPartList[];
}

export type PartsComponent = React.FC<PartsProps>;

const Parts: PartsComponent = ({ parts }) => {
    const { t } = useTranslation('workorder');
    const { t: tMaterial } = useTranslation('material');
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={classes.card}>
        <div className={classes['header']} onClick={() => setExpanded(prev => !prev)}>
            <h2 className={classes['header-title']}>
                <Icon name="build" size={20} className={classes['section-header-icon']} />
                {tMaterial('parts')}
            </h2>
            {false && <button type="button" className={classes['add-action']} aria-hidden tabIndex={-1}>
                + {tMaterial('add')}
            </button>}
            <Icon name={expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} className={classes['chevron']} />
        </div>
        {expanded && (
            parts.length === 0 ? (
                <p className={classes.empty}>{t('detail.noParts')}</p>
            ) : (
                <div className={classes.list}>
                    {parts.map(part => (
                        <div key={part.id} className={classes['list-row']}>
                            <div className={classes['row-main']}>
                                <LineTypeIcon type={part.type} issueId={part.issueId} />
                                <p className={classes['row-name']}>{part.name}</p>
                            </div>
                            <div className={classes['row-actions']}>
                                <span className={classes['row-quantity']}>
                                    {part.quantity} {tMaterial('item')}
                                </span>
                                {false && <Icon name="delete" size={20} className={classes['row-delete']} />}
                            </div>
                        </div>
                    ))}
                    </div>
                )
            )}
        </div>
    );
};

export default Parts;